<template>
  <download-excel :name="fileName" v-bind="$attrs">
    <v-btn color="success" class="me-3" small>
      <v-icon class="me-1" small> mdi-file-excel </v-icon>
      {{ $t('shared.exportExcel') }}
    </v-btn>
  </download-excel>
</template>

<script>
import {toTimeZoneString} from '@/lib/utils'
export default {
  name: 'ExportExcel',
  inheritAttrs: false,
  props: {
    name: {type: String, default: ''}
  },
  computed: {
    fileName() {
      return toTimeZoneString()
    }
  }
}
</script>
